import { render, staticRenderFns } from "./TopTabs.vue?vue&type=template&id=526ae7e8&scoped=true"
import script from "./TopTabs.vue?vue&type=script&lang=js"
export * from "./TopTabs.vue?vue&type=script&lang=js"
import style0 from "./TopTabs.vue?vue&type=style&index=0&id=526ae7e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526ae7e8",
  null
  
)

export default component.exports